'use client';

import React from 'react';
import Header from './Header';
import Footer from './Footer';
import { ErrorBoundary } from '@/components/ErrorBoundary';

/**
 * Layout 组件 - 主布局组件
 * 包含 Header 和 Footer，内容区域由页面模板组件处理
 */
export default function Layout({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col">
      <ErrorBoundary fallback={<div style={{ padding: '10px', background: '#fee', border: '1px solid #f00' }}>Header Error</div>}>
        <Header />
      </ErrorBoundary>
      <div id="content" className="site-content flex-1">
        {children}
      </div>
      <ErrorBoundary fallback={<div style={{ padding: '10px', background: '#fee', border: '1px solid #f00' }}>Footer Error</div>}>
        <Footer />
      </ErrorBoundary>
    </div>
  );
}

